import * as type from "./type";

export const getVendorLogListRequest = (data) => {
  return {
    type: type.GET_VENDOR_LOG_LIST_REQUEST,
    payload: data,
  };
};
export const getVendorLogListSuccess = (data) => {
  return {
    type: type.GET_VENDOR_LOG_LIST_SUCCESS,
    payload: data,
  };
};
export const deleteVendorLogRequest = (data) => {
  return {
    type: type.DELETE_VENDOR_LOG_REQUEST,
    payload: data,
  };
};
export const deleteVendorLogSuccess = (data) => {
  return {
    type: type.DELETE_VENDOR_LOG_SUCCESS,
    payload: data,
  };
};
export const clearVendorLogList = () => {
  return {
    type: type.CLEAR_VENDOR_LOG_LIST,
  };
};
